import React from "react"
import { Link } from "gatsby"
import './layout.css'
import { rhythm} from "../utils/typography"
import {isLoggedIn,handleLogin} from './services/auth'


const  Navi = () => (
  <div style={{
    display:"flex",
    background:"rgab(122,122,122,.4)",
    flexDirection:"column",
    justifyContent:"flex-start",
    alignItems:"center",
    width:"100%"
  }}>
 
  <ul className="naviul" style={{listStyle:"none",padding:"4px",fontSize:'1rem'}}>
    <li><Link to="/wohnen">Zimmer</Link></li>
    <li><Link to="/kultur">Kultur</Link></li>
    <li><Link to="/herrliche-Landschaft">Natur</Link></li>
    <li><Link to="/urlaubstipps">Tipps</Link></li>
    
  </ul>
  </div>
)



class Layout extends React.Component {
  state={
    zugestimmt:false
  }

  componentWillMount(){
    if ((typeof window !== "undefined")) {
       let drin = isLoggedIn()
       if(!drin){
        this.setState({zugestimmt:false})
       }
        
       else  {
        this.setState({zugestimmt:true}) 
       }
         
    }     
}
zustimmen =(e) =>{
  e.preventDefault()
  this.setState({zugestimmt:true})
  handleLogin({username:'john',password:'pass'})
  return ""
}
  render() {
    const { title, children } = this.props
    //const rootPath = `${__PATH_PREFIX__}/`
    let header
      header = (
        <div className="header1">
         
                <h1
          style={{
            textAlign:`center`,
            letterSpacing:`.09rem`
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `white`,
              letterSpacing:`.13rem`,
              fontSize:'1.7rem'
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
        
          </div>
           
        
      )
    
    return (
     
      <div id="scrollsite"
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: rhythm(24),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
          background: `rgb(112,112,112,.7)`,
          overflow:`scroll`,
          height: `100vh`
        }}
      >
        <header>{header}</header>
        <Navi />
       {
         this.state.zugestimmt===false &&
         (
           <div id="blue-car">
            <h2>Auch wir nutzen Cookies ...</h2>
            <p><Link to= "/datenschutz"> &rarr; Datenschutzbestimmungen</Link></p>
            <button onClick={this.zustimmen}>Ich stimme zu!</button>
           </div>
           )
         
       }
        
        <main>{children}</main>
        <footer>
        
  <ul style={{listStyle:"none",padding:"4px",fontSize:'1rem'}}>
    <li><Link to="/impressum">Impressum</Link></li>
    <li><Link to="/kontakt">Kontakt</Link></li>
    <li><Link to="/datenschutz">Datenschutz</Link></li>
  </ul>
 
        </footer>
      </div>
      
    )
  }
}

export default Layout
